import { ROUTES } from '@/lib/routes';
import { ContentStatus } from '@addmile/backend-client';

export const NEW_JOURNEY_ID = 'new';

export const journeyPath = (id: string) => ROUTES.CONTENT_JOURNEY.replace(':id', id);

// The app's mile tones, in the order the backend backfilled existing miles with.
export const MILE_COLORS = ['#843DFF', '#FC803A', '#29BB6C', '#FF3838'];

export const DEFAULT_JOURNEY_COLOR = MILE_COLORS[0];

// Mirrors the backend's supported brands; it rejects a journey for any other.
export const JOURNEY_BRANDS = [
  { value: 'addmile', label: 'AddMile' },
  { value: 'relaya', label: 'Relaya' },
  { value: 'innerly', label: 'Innerly' },
];

export const STATUS_HINTS: Record<ContentStatus, string> = {
  [ContentStatus.Online]: 'visible to users',
  [ContentStatus.Offline]: 'hidden from users',
  [ContentStatus.Draft]: 'not published yet',
};

export const CHECK_IN_ICON = '/icons/previewer/check-in.svg';
